'use strict';

/**
 * A helper function to add a focus ring to an element.
 * Use in conjunction with the `focus-visible` pseudo-class.
 *
 * @param theme - The theme object
 * @param offset - The offset of the focus ring in pixels
 * @param borderRadius - The border radius of the focus ring
 * @returns The focus ring styles
 */ const focusRing = (theme, offset = 1, borderRadius = "4px")=>({
        outline: `${theme.ds5.effect.focused.stroke} solid ${theme.ds5.effect.focused.border}`,
        outlineOffset: `${offset}px`,
        borderRadius: `${borderRadius}`
    });

exports.focusRing = focusRing;
//# sourceMappingURL=focusRing.cjs.map
